import React from 'react';
import { Link } from 'react-router-dom';
import { viewReceipt, deletePayment } from './Payment';
import { getCurrency, getShortDate, toggleOptionsMenu } from '../../Helper';

function PaymentTable(props) {
    const defaultOptions = {
        fields: {
            success: true,
            type: true,
            details: true,
            amount: true,
            processingFee: true,
            total: true,
            transactionId: true,
            paidDate: true,
            actions: true
        },
        footer: {
            feePaymentTotal: true,
            paymentTotal: false
        },
        actions: {
            add: false,
            view: true,
            edit: true,
            receipt: true,
            delete: true
        },
        details: {
            accountNumber: false,
            account: false,
            identifier: true,
            amount: true,
            CheckNumber: false
        }
    }
    const options = { ...defaultOptions, ...props.options };

    const tableBody = props.payments.sort((a, b) => b.paidDate - a.paidDate).map(p => {
        const viewURL = '/admin/payments/' + p.paymentID;
        const editURL = '/admin/payments/' + p.paymentID + '/edit';
        const successIcon = p.isSuccessful ? (<i className="fas fa-check-square"></i>) : (<i className="far fa-square"></i>);

        const feePaymentSort = props.feeId ?
            (a, b) => a.feeID === b.feeID ? 0 : a.feeID === props.feeId ? -1 : 1
            :
            (a, b) => a.fee.identifier > b.fee.identifier;
        const paymentDetails = p.feePayments.sort(feePaymentSort).map(fp => {
            return (
                <div key={fp.feeID} className={'payment-table-detail' + (props.feeId && fp.feeID !== props.feeId ? ' font-small' : '')}>
                    {options.details.accountNumber ? (<span>{fp.fee.account.accountNumber}</span>) : null}
                    {options.details.account ? (<span>{fp.fee.account.name}</span>) : null}
                    {options.details.identifier ? (<span>{fp.fee.identifier}</span>) : null}
                    {options.details.amount ? (<span>{getCurrency(fp.paymentAmount)}</span>) : null}
                </div>
            );
        });

        return (
            <tr key={p.paymentID}>
                {options.fields.success ? (
                    <td className="center">
                        <div className="icon-label">{successIcon} <span>{p.isSuccessful ? "Successful" : "Unsuccessful" }</span></div>
                    </td>
                ) : null}
                {options.fields.type ? (
                    <td>
                        <span>{p.paymentType?.paymentTypeName ?? 'NA'}</span>
                    </td>
                ) : null}
                {options.fields.details ? (
                    <td>
                        <span>{paymentDetails}</span>
                    </td>
                ) : null}
                {options.fields.amount ? (
                    <td>
                        <span>{getCurrency(p.paymentAmount)}</span>
                    </td>
                ) : null}
                {options.fields.processingFee ? (
                    <td>
                        <span>{getCurrency(p.processingFeeAmount || 0)}</span>
                    </td>
                ) : null}
                {options.fields.total ? (
                    <td>
                        <span>{getCurrency(p.paymentAmount + (p.processingFeeAmount || 0))}</span>
                    </td>
                ) : null}
                {options.fields.transactionId ? (
                    <td>
                        <span>{p.transactionID}</span>
                    </td>
                ) : null}
                {options.fields.paidDate ? (
                    <td>
                        <span>{getShortDate(p.paidDate)}</span>
                    </td>
                ) : null}
                {options.fields.actions ? (
                    <td>
                        <div className="actions">
                            {options.actions.view ?
                                (<Link to={viewURL} className="action-icon action-view">
                                    <i className="fas fa-eye"></i>
                                </Link>)
                                : null
                            }
                            {/*{options.actions.edit && window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ?*/}
                            {/*    (<Link to={editURL} className="action-icon action-edit">*/}
                            {/*        <i className="fas fa-edit"></i>*/}
                            {/*    </Link>)*/}
                            {/*    : null*/}
                            {/*}*/}
                            {/*{(options.actions.receipt && window.env.user.userRoles.some(ur => [1, 2, 3, 4].includes(ur.roleID))) || (options.actions.delete && window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID))) ?*/}
                            {/*    (<div onClick={toggleOptionsMenu} className="action-icon action-dropdown">*/}
                            {/*        <i className="fas fa-ellipsis-h"></i>*/}
                            {/*        <div className="action-dropdown-menu">*/}
                            {/*            {options.actions.receipt && window.env.user.userRoles.some(ur => [1, 2, 3, 4].includes(ur.roleID)) ?*/}
                            {/*                (<div className="action-dropdown-menu-item" onClick={() => viewReceipt(p.paymentID)}><span>View Receipt</span></div>)*/}
                            {/*                : null*/}
                            {/*            }*/}
                            {/*            {options.actions.delete && window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ?*/}
                            {/*                (<div className="action-dropdown-menu-item" onClick={async () => await props.deletePaymentRecord(p.paymentID)}><span>Delete</span></div>)*/}
                            {/*                : null*/}
                            {/*            }*/}
                            {/*        </div>*/}
                            {/*    </div>)*/}
                            {/*    : null*/}
                            {/*}*/}
                        </div>
                    </td>
                ) : null}
            </tr>
        );
    });

    //May not be able to use ?. and ?? for Internet Explorer support.
    const thisAmounts = props.feeId ?
        props.payments.filter(p => p.isSuccessful).map(p => p.feePayments.find(fp => fp.feeID == props.feeId).paymentAmount)
        : props.payments.filter(p => p.isSuccessful).map(p => p.feePayments.map(fp => fp.paymentAmount).reduce((a, b) => a + b, 0));
    const thisAmount = thisAmounts.reduce((a, b) => a + b, 0);
    const totalSuccessAmount = props.payments.filter(p => p.isSuccessful).map(p => p.paymentAmount).reduce((a, b) => a + b, 0);
    const totalAmount = props.payments.map(p => p.paymentAmount).reduce((a, b) => a + b, 0);
    const paymentTotal = props.payments.map(p => p.paymentAmount + p.processingFeeAmount).reduce((a, b) => a + b, 0);

    return (
        <table className="table payment-table">
            <thead>
                <tr>
                    {options.fields.success ? (
                        <th>
                            <span>Success</span>
                        </th>
                    ) : null}
                    {options.fields.type ? (
                        <th>
                            <span>Type</span>
                        </th>
                    ) : null}
                    {options.fields.details ? (
                        <th>
                            <span>Details</span>
                        </th>
                    ) : null}
                    {options.fields.amount ? (
                        <th>
                            <span>Subtotal</span>
                        </th>
                    ) : null}
                    {options.fields.processingFee ? (
                        <th>
                            <span>Processing Fee</span>
                        </th>
                    ) : null}
                    {options.fields.total ? (
                        <th>
                            <span>Total Amount</span>
                        </th>
                    ) : null}
                    {options.fields.transactionId ? (
                        <th>
                            <span>Transaction ID</span>
                        </th>
                    ) : null}
                    {options.fields.paidDate ? (
                        <th>
                            <span>Paid Date</span>
                        </th>
                    ) : null}
                    {options.fields.actions ? (
                        <th>
                        </th>
                    ) : null}
                </tr>
            </thead>
            <tbody>
                {tableBody}
            </tbody>
            {Object.values(options.footer).some(v => v) ? (
                <tfoot>
                    <tr>
                        {options.fields.success ? (
                            <td>
                            </td>
                        ) : null}
                        {options.fields.type ? (
                            <td>
                            </td>
                        ) : null}
                        {options.fields.details ? (
                            <td>
                                {options.footer.feePaymentTotal ?
                                    (<span>{getCurrency(thisAmount)}</span>)
                                    : null
                                }
                            </td>
                        ) : null}
                        {options.fields.amount ? (
                            <td>
                                {options.footer.amountTotal ?
                                    (<span>{getCurrency(totalAmount)}</span>)
                                    : null
                                }
                            </td>
                        ) : null}
                        {options.fields.processingFee ? (
                            <td>
                            </td>
                        ) : null}
                        {options.fields.total ? (
                            <td>
                                {options.footer.paymentTotal ?
                                    (<span>{getCurrency(paymentTotal)}</span>)
                                    : null
                                }
                            </td>
                        ) : null}
                        {options.fields.transactionId ? (
                            <td>
                            </td>
                        ) : null}
                        {options.fields.paidDate ? (
                            <td>
                            </td>
                        ) : null}
                        {options.fields.actions ? (
                            <td>
                            </td>
                        ) : null}
                    </tr>
                </tfoot>
            ) : null}
        </table>
    );
}

export default PaymentTable;